module.exports = __webpack_public_path__ + "img/Plane.9f0a1025.jpg";